module.exports = __webpack_public_path__ + "static/media/dromarkivet_square.7e84b727.png";